module.exports = __webpack_public_path__ + "static/media/bringForwards.b9f8a9c3.svg";